<template>
    <div
        v-if="initialized"
        class="overflow-hidden">
        <div
            v-if="findRoute && allocationStatus !== -1"
            class="flex justify-end mb-3">
            <hts-form-button
                :loading="btnFindRoute.loading"
                color="info"
                type="button"
                :outline="false"
                @click="handleFindRoute">
                Cập nhật tuyến
            </hts-form-button>
        </div>
        <div class="flex w-full h-full overflow-hidden gap-2 mb-2">
            <div class="w-1/2 max-h-[800px] flex flex-col">
                <div class="space-x-2 flex-none">
                    <driver-info :drivers="cDriver" />
                    <vehicle-info :vehicles="[vehicle]" />
                </div>
                <travel-route-info
                    class="flex-1"
                    :journey="journey"
                    @open-planning="openPlanning"
                    @open-timing="openTiming"
                    @open-change-vehicle="openChangeVehicle"
                    @open-change-vehicle-and-mooc="openChangeVehicleAndMooc" />
            </div>
            <div class="w-1/2 max-h-[800px]">
                <div class="h-[400px]">
                    <hts-map-route
                        v-if="visibleMap"
                        ref="map"
                        center-marker
                        :route="markers"
                        :route-separated="routes"
                        :draggable="false"
                        :show-location="showLocation"
                        :lat-lng-location-routes="CLatLngLocationRoutes">
                        <template #top>
                            <div class="flex min-h-5 justify-end gap-3">
                                <hts-map-icon-location />
                            </div>
                        </template>
                    </hts-map-route>
                </div>
                <hts-ui-tabs
                    v-model="tab"
                    :tabs="tabs" />
                <div class="max-h-[360px] overflow-auto pr-1">
                    <div v-if="tab === 'alerts'">
                        <journey-alerts :journey="journey" />
                    </div>
                    <div v-if="tab === 'files'">
                        <journey-files :journey-id="journey._id" />
                    </div>
                </div>
            </div>
        </div>

        <hts-modal
            :show="showModalNotFoundRoute"
            size="small"
            @hide="
                () => {
                    showModalNotFoundRoute = false
                }
            ">
            <div>
                <p class="mt-5">
                    Chưa có thông tin tuyến đường trên hệ thống. Vui lòng liên hệ Điều độ để thực hiện vẽ tuyến.
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalWarningStatus"
            @hide="
                () => {
                    showModalWarningStatus = false
                }
            ">
            <div>
                <p class="mt-5">
                    Bạn không thể cập nhật tuyến đường do đơn hàng đã được được phân bổ.
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalConfirmChangeRoute"
            @hide="
                () => {
                    showModalConfirmChangeRoute = false
                }
            ">
            <div>
                <p class="mt-5">
                    Kế hoạch vận chuyển sẽ được tính toán lại theo tuyến đường mới nhất trên hệ thống. Vui lòng xác nhận nếu bạn muốn muốn tiếp tục?
                </p>

                <div class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="button"
                        :outline="false"
                        @click="handleConfirmChangeRoute()">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-modal>

        <hts-modal
            v-model="visiblePlanning"
            size="large"
            :title="$t('labels.planningModify')">
            <info-planning
                ref="tabPlanning"
                :editable="true"
                :journey="journey"
                :order="dataOrder"
                @change="handleJourneyChange"
                @cancel="visiblePlanning = false" />
        </hts-modal>

        <hts-modal
            v-model="visibleTiming"
            size="large"
            type="confirm"
            title="Điều chỉnh thời gian"
            :loading="editTimeLoading"
            @confirm="handleUpdateTime">
            <hts-travel-details
                v-if="travelDetails.length"
                ref="travelRouteEdit"
                :journey-id="journey._id"
                :travel-details="travelDetails"
                :stage-start="stageIndexStart"
                :stage-end="stageIndexEnd"
                :start="journey.travelIndexStart"
                :end="journey.travelIndexEnd"
                :edit-time="true"
                direction="horizontal"
                class="flex-1 overflow-auto" />
        </hts-modal>

        <hts-modal
            v-model="visibleChangeVehicle"
            size="large"
            type="confirm"
            title="Cắt Mooc"
            :loading="loadingChangeVehicle"
            @confirm="handleChangeVehicle">
            <hts-select-option
                v-model="changeVehicleForm.type"
                :items="changeVehicleTypeOptions" />
            <hts-map-node
                v-if="changeVehicleForm.type === 'map'"
                class="mt-1"
                @click="handleClickOnMap" />
        </hts-modal>

        <hts-modal
            v-model="visibleChangeVehicleAndMooc"
            size="large"
            title="Đổi xe">
            <hts-form
                ref="changeVehicleAndMoocRef"
                :rules="changeVehicleAndMoocRules">
                <hts-form-select
                    v-model="changeVehicleAndMoocForm.travelId"
                    label="Vị trí đổi"
                    :items="travelStagies"
                    key-id="_id"
                    key-label="nodeName"
                    required />
                <hts-form-select
                    v-model="changeVehicleAndMoocForm.taskId"
                    label="Tác vụ đổi"
                    :items="changeVehicleAndMoocTasks"
                    key-id="_id"
                    key-label="taskName"
                    required />
                <div class="modal-action">
                    <hts-form-button
                        :loading="loadingChangeVehicleAndMooc"
                        color="primary"
                        icon-position="right"
                        type="submit"
                        @click="handleChangeVehicleAndMooc">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                    <hts-form-button
                        icon-position="right"
                        @click="visibleChangeVehicleAndMooc = false">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
    </div>
</template>

<script setup lang="ts">
import JourneyAlerts from './alerts.vue'
import DriverInfo from './driver-info.vue'
import JourneyFiles from './files.vue'
import InfoPlanning from './planning.vue'
import TravelRouteInfo from './travel-route-info.vue'
import VehicleInfo from './vehicle-info.vue'
import routeMap from '@/pages/trucker-[id]/route/ignore/route-map'

const { markers, setMarkers, routes, setRoutes, setRoutingPositions, showLocation, CLatLngLocationRoutes } = routeMap()

const emits = defineEmits(['modify', 'update-route', 'journey-changed', 'open-timing', 'open-planning', 'journey-time-changed'])
const initialized = ref(false)
const visiblePlanning = ref(false)
const visibleTiming = ref(false)
const visibleMap = ref(false)
const props = defineProps({
  journey: {
    type: Object,
    required: true
  },
  findRoute: {
    type: Function
  },
  allocationStatus: {
    type: Number,
    default: 4
  }
})

const { journey, findRoute, allocationStatus } = toRefs(props)

const tabs = ref([
  {
    label: 'Cảnh báo',
    key: 'alerts'
  },
  {
    label: 'Tài liệu',
    key: 'files'
  }
])
const tab = ref('alerts')
const dataOrder = computed<any>(() => journey.value?.order || {})
const travelDetails = ref([])
const stageIndexStart = computed(() => journey.value?.stageIndexBegin || journey.value?.stageIndexStart)
const stageIndexEnd = computed(() => journey.value?.stageIndexEnd)
const travelIndexStart = computed(() => journey.value?.travelIndexStart)
const travelIndexEnd = computed(() => journey.value?.travelIndexEnd)
const travelStagies = computed(() => travelDetails.value.filter((t: any) => t.type === 'stage'))

const btnFindRoute = ref({
  loading: false
})

const showModalNotFoundRoute = ref(false)
const showModalConfirmChangeRoute = ref(false)
const showModalWarningStatus = ref(false)
const route = ref({} as any)

const vehicle = computed(() => journey.value?.vehicle || journey.value?.vehicleTemp)
const driver = computed(() => vehicle.value?.otherCompanyDriver || vehicle.value?.driver)
const coDriver = computed(() => vehicle.value?.otherCompanyCoDriver || vehicle.value?.coDriver)
const cDriver = computed(() => {
  if (coDriver.value) {
    return [driver.value, coDriver.value]
  }

  return [driver.value]
})
onMounted(() => {
  travelDetails.value = $lodash.cloneDeep(journey.value?.travelDetails)
  nextTick(() => {
    initialized.value = true
    visibleMap.value = true
    nextTick(() => {
      show(journey.value)
    })
  })
})

const show = (journey: any) => {
  if (journey.routingPositions) {
    setRoutingPositions(journey.routingPositions)
    setMarkers(journey.stages, {
      renderMarkerByIndexNumber: true
    })
    setRoutes(journey.stages, {
      renderMarkerByIndexNumber: true
    })
  }
}

const handleFindRoute = async () => {
  btnFindRoute.value.loading = true
  if (!findRoute?.value) {
    btnFindRoute.value.loading = false
    return
  }

  if (allocationStatus.value === 5 || allocationStatus.value === 6) {
    btnFindRoute.value.loading = false
    showModalWarningStatus.value = true
    return
  }

  route.value = await findRoute.value({ modules: ['ROUTE'] })

  if (!route.value) {
    showModalNotFoundRoute.value = true
  } else {
    showModalConfirmChangeRoute.value = true
  }
  btnFindRoute.value.loading = false
}

const handleConfirmChangeRoute = () => {
  showModalConfirmChangeRoute.value = false
  emits('update-route', route.value)
}

const openPlanning = (e: any) => {
  emits('open-planning', e)
  visiblePlanning.value = true
}
const openTiming = (e: any) => {
  emits('open-timing', e)
  visibleTiming.value = true
}

const handleJourneyChange = () => {
  emits('journey-changed')
  visiblePlanning.value = false
}

const editTimeLoading = ref(false)
const handleUpdateTime = () => {
  const updateArr: any[] = []
  editTimeLoading.value = true
  travelDetails.value.forEach((item: any, i: number) => {
    if (i >= travelIndexStart.value && i <= travelIndexEnd.value) {
      updateArr.push({
        _id: item._id,
        ata: item.ata,
        atd: item.atd
      })
    }
  })
  $api($url.monitoring.journey.setActualTimeMultiple, { uriParams: { ID: journey.value._id }, body: { updateArr } })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        process.client && $toast().success($t('labels.updateSuccess'))
      }
      visibleTiming.value = false
      editTimeLoading.value = false
      emits('journey-changed')
    })
    .catch(() => {
      editTimeLoading.value = false
    })
}

const visibleChangeVehicle = ref(false)
const loadingChangeVehicle = ref(false)
const changeVehicleForm = reactive({
  type: 'map',
  mapPosition: null
})
const changeVehicleTypeOptions = ref([
  { name: 'Vị trí trên bản đồ', value: 'map' },
  { name: 'Vị trí hiện tại của xe', value: 'vehicle' }
])
const openChangeVehicle = () => {
  visibleChangeVehicle.value = true
}
const handleChangeVehicle = () => {
  // if (!vehicle.value) {
  //   process.client && $toast().error('Chặng chưa có xe')
  //   return
  // }
  // if (!journey.value.startAtActual) {
  //   process.client && $toast().error('Chặng chưa khởi hành')
  //   return
  // }

  loadingChangeVehicle.value = true
  $api($url.monitoring.journey.changeVehicle, { uriParams: { ID: journey.value._id }, body: changeVehicleForm }).then(({ data }: any) => {
    const { success } = data || {}
    loadingChangeVehicle.value = false
    if (success) {
      visibleChangeVehicle.value = false
      process.client && $toast().success('Đổi thành công')
      emits('journey-changed')
    }
  })
}
const handleClickOnMap = (position: any) => {
  changeVehicleForm.mapPosition = position
}

const visibleChangeVehicleAndMooc = ref(false)
const loadingChangeVehicleAndMooc = ref(false)
const changeVehicleAndMoocFormStage = computed<any>(() => travelDetails.value.find((t: any) => t._id === changeVehicleAndMoocForm.travelId))
const changeVehicleAndMoocTasks = computed(() =>
  travelDetails.value.filter((t: any) => t.type === 'task' && t.stageIndex === changeVehicleAndMoocFormStage.value?.stageIndex)
)
const changeVehicleAndMoocForm = reactive({
  travelId: '',
  taskId: ''
})
const changeVehicleAndMoocRules = reactive({
  travelId: 'required',
  taskId: 'required'
})
const changeVehicleAndMoocRef = ref<any>(null)
const openChangeVehicleAndMooc = () => {
  visibleChangeVehicleAndMooc.value = true
}
const handleChangeVehicleAndMooc = () => {
  loadingChangeVehicleAndMooc.value = true
  $api($url.monitoring.journey.changeVehicleAndMooc, { uriParams: { ID: journey.value._id }, body: changeVehicleAndMoocForm }).then(({ data }: any) => {
    const { success } = data || {}
    loadingChangeVehicleAndMooc.value = false
    if (success) {
      visibleChangeVehicleAndMooc.value = false
      process.client && $toast().success('Đổi thành công')
      emits('journey-changed')
    }
  })
}
defineExpose({
  show,
  close
})
</script>
